import Framework from '@greenville/framework';
import { Checkbox, FormGroup, Grid, TextField, TextareaAutosize, makeStyles } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import * as constants from '../../../common/constants';
import env from '../../../common/env';
import utils from '../../../common/utils';
// import AutocompleteComponent from '../../chatUtility/common/components/Autocomplete';

const useStyles = makeStyles({
  flexBorder: {
    border: '1px solid grey',
    margin: '75px',
    borderRadius: '4px'
  },
  gridColumns: {
    display: 'flex',
    justifyContent: 'center'
  },
  flexContainerBottom: {
    display: 'flex',
    justifyContent: 'center',
    borderTop: '1px solid grey',
    borderBottom: '1px solid grey',
    padding: '10px'
  },
  ButtonClass: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '100%'
  },
  textAreaSize: {
    width: '77%'
  },
  labelColumns: {
    display: 'flex',
    justifyContent: 'start',
    paddingLeft: '60px',
    paddingBottom: '10px'
  },
  subLable: {
    fontWeight: '600 !important',
    fontSize: '14px !important',
    width: '77%',
    marginTop: '5px',
    marginBottom: '5px !important'
  },
  flexContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid grey'
  },
  checkboxContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  versionText: {
    fontSize: '10px',
    fontStyle: 'italic',
    textDecoration: 'underline'
  }
});

// const { version } = require('@vega/aitutor/package.json');

const DynamicTestFields = () => {
  const history = useHistory();
  const classes = useStyles();
  const [tenant, setTenant] = useState('');
  const [tenants, setTenants] = useState([]);
  // const [bookDataList, setBookDataList] = useState([]);
  const [inputValue, setInputValue] = useState({
    tenantId: '',
    tenantKey: '',
    tenantName: '',
    courseId: '',
    pageId: '',
    userId: '',
    bookTitle: '',
    message: '',
    tutorName: '',
    berlinEnv: '',
    expandMode: false,
    productModel: '',
    tocId: '',
    enableProblemSolveFeature: true,
    showRecommendedPrompts: true,
    AIEnableHigherOrderSuggestion: true,
    AIEnableNewValidateAnswer: true,
    AIEnableQuizRandomization: true,
    enableExplainQuizOptions: ''
  });

  useEffect(() => {
    const getTenantsConfig = async () => {
      const tokenValue = utils.getToken();
      const headers = {
        Authorization: `Bearer ${tokenValue}`
      };
      try {
        const response = await axios.post(
          `${env.EVERGREEN_API_BASE_URL}${constants.GET_TENANTS_CONFIG_DATA_URL}`,
          {},
          { headers }
        );
        if (response && response.data && response.data.data) {
          setTenants(response.data.data);
        }
      } catch (error) {
        const notification = {
          open: true,
          message: 'Error fetching tenants',
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    };

    getTenantsConfig();
  }, []);

  useEffect(() => {
    const tenantObj = tenants.find((tenantItem) => tenantItem.name === tenant);
    setInputValue({
      ...inputValue,
      tenantId: tenantObj?.tenantId,
      tenantKey: tenantObj?.tenantKey,
      tenantName: tenantObj?.name,
      productModel: tenantObj?.name === constants.PVS ? 'EXTERNAL_PVS' : ''
    });
  }, [tenant]);

  const handleInputChange = (event) => {
    const {
      target: { name, value, type, checked }
    } = event;
    if (type === 'checkbox') setInputValue((prevInput) => ({ ...prevInput, [name]: checked }));
    else setInputValue((prevInput) => ({ ...prevInput, [name]: value }));
  };

  const handleTenant = (event) => {
    setTenant(event.target.value);
  };

  const handleSave = () => {
    history.push('/configure/aistudytest', inputValue); // Pass the data via state
  };

  // useEffect(() => {
  //   const tokenValue = utils.getToken();
  //   const getBookData = async () => {
  //     const headers = {
  //       Authorization: `Bearer ${tokenValue}`,
  //       [constants.BERLIN_TENANT_ID_HEADER]: inputValue.tenantId
  //     };
  //     const response = await axios.post(`${env.EVERGREEN_API_BASE_URL}${constants.GET_BOOK_DATA_URL}`, {}, { headers });
  //     if (response && response.data && response.data.data) {
  //       const bookData = response?.data?.data;

  //       if (bookData && Array.isArray(bookData)) {
  //         setBookDataList(bookData);
  //       }
  //     }
  //   };
  //   if (inputValue.tenantId) {
  //     getBookData();
  //   }
  // }, [inputValue.tenantId]);

  useEffect(() => {
    setInputValue((prevInput) => ({ ...prevInput, courseId: '', bookTitle: '' }));
  }, [inputValue.tenantId]);

  // const onInputChange = (event, newInputValue) => {
  //   setInputValue((prevInput) => ({ ...prevInput, bookTitle: newInputValue !== null ? newInputValue : '' }));
  // };

  // const onAutoCompleteChange = (event, newValue) => {
  //   setInputValue((prevInput) => ({
  //     ...prevInput,
  //     courseId: newValue !== null ? newValue.bookId : '',
  //     bookTitle: newValue !== null ? newValue.title : ''
  //   }));
  // };

  return (
    <>
      <div className={classes.flexBorder}>
        <Box>
          <Grid item xs={16}>
            <Typography variant="h5" align="center" gutterBottom spacing={9}>
              Configure AI Study Tools
            </Typography>
          </Grid>
        </Box>
        <Box sx={{ width: '100%', top: '13%' }}>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
            <Grid container direction="row" style={{ justifyContent: 'center' }}>
              <Grid item xs={10} direction="row">
                <Box sx={{ display: 'flex', justifyContent: 'space-between', p: '0px 32px' }}>
                  {/* eslint-disable */}
                  <FormControl sx={{ mt: 1, width: '45%' }} size="small" required>
                    <InputLabel id="tenant">Select Tenant</InputLabel>
                    <Select
                      labelId="tenant-label"
                      label="Select Tenant"
                      name="tenant"
                      onChange={handleTenant}
                      value={tenant}
                    >
                      {tenants.map((t) => (
                        <MenuItem key={t.name} value={t.name}>
                          {t.title}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <TextField
                    label="Tenant ID"
                    style={{ minWidth: '45%' }}
                    margin="dense"
                    name="tenantId"
                    onChange={handleInputChange}
                    value={inputValue.tenantId}
                    variant="outlined"
                    required
                  />
                </Box>
              </Grid>
            </Grid>

            <Grid container direction="row" style={{ justifyContent: 'center' }}>
              <Grid item xs={10} direction="row">
                <Box sx={{ display: 'flex', justifyContent: 'space-between', p: '0px 32px' }}>
                  <TextField
                    label="Tenant Key"
                    style={{ minWidth: '45%' }}
                    margin="dense"
                    name="tenantKey"
                    onChange={handleInputChange}
                    value={inputValue.tenantKey}
                    variant="outlined"
                    required
                  />
                  <TextField
                    label="Product Model"
                    style={{ minWidth: '45%' }}
                    margin="dense"
                    name="productModel"
                    onChange={handleInputChange}
                    value={inputValue.productModel}
                    variant="outlined"
                    required
                  />
                </Box>
              </Grid>
            </Grid>

            <Grid container direction="row" style={{ justifyContent: 'center' }}>
              <Grid item xs={10} direction="row">
                <Box sx={{ display: 'flex', justifyContent: 'space-between', p: '0px 32px' }}>
                  {/* eslint-disable */}
                  <FormControl sx={{ mt: 1, width: '45%' }} size="small" required>
                    <InputLabel id="expandMode">Expand Mode</InputLabel>
                    <Select
                      label="Expand Mode"
                      name="expandMode"
                      onChange={handleInputChange}
                      value={inputValue.expandMode}
                    >
                      <MenuItem value={true}>TRUE</MenuItem>
                      <MenuItem value={false}>FALSE</MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl sx={{ mt: 1, width: '45%' }} size="small" required>
                    <InputLabel id="berlinEnv">Berlin Environment</InputLabel>
                    <Select
                      label="Berlin Environment"
                      name="berlinEnv"
                      onChange={handleInputChange}
                      value={inputValue.berlinEnv}
                    >
                      <MenuItem value={'prod'}>Prod</MenuItem>
                      <MenuItem value={'ppe'}>Pre Prod</MenuItem>
                      <MenuItem value={'stage'}>Stage</MenuItem>
                      <MenuItem value={'qa'}>Dev</MenuItem>
                      <MenuItem value={'local'}>Local</MenuItem>
                    </Select>
                  </FormControl>

                  {/* eslint-disable */}
                </Box>
              </Grid>
            </Grid>
            <Grid container direction="row" style={{ justifyContent: 'center' }}>
              <Grid item xs={10} direction="row">
                <Box sx={{ display: 'flex', justifyContent: 'space-between', p: '0px 32px' }}>
                  {/* <FormControl sx={{ mt: 1, width: '45%' }} size="small" required>
                    <AutocompleteComponent
                      options={bookDataList}
                      onAutoCompleteChange={onAutoCompleteChange}
                      onInputChange={onInputChange}
                      stateVal={inputValue.bookTitle}
                      errorVal=""
                      name="courseId"
                      label="Course Id"
                    />
                  </FormControl> */}
                  <TextField
                    label="Course Id"
                    style={{ minWidth: '45%' }}
                    margin="dense"
                    name="courseId"
                    onChange={handleInputChange}
                    value={inputValue.courseId}
                    variant="outlined"
                    required
                  />
                  <TextField
                    label="Heading"
                    style={{ minWidth: '45%' }}
                    margin="dense"
                    name="tutorName"
                    onChange={handleInputChange}
                    value={inputValue.tutorName}
                    variant="outlined"
                  />
                </Box>
              </Grid>
            </Grid>

            <Grid container direction="row" style={{ justifyContent: 'center' }}>
              <Grid item xs={10} direction="row">
                <Box sx={{ display: 'flex', justifyContent: 'space-between', p: '0px 32px' }}>
                  <TextField
                    label="Page ID"
                    style={{ minWidth: '45%' }}
                    margin="dense"
                    name="pageId"
                    onChange={handleInputChange}
                    value={inputValue.pageId}
                    variant="outlined"
                  />
                  <TextField
                    label="User ID"
                    style={{ minWidth: '45%' }}
                    margin="dense"
                    name="userId"
                    onChange={handleInputChange}
                    value={inputValue.userId}
                    variant="outlined"
                  />
                </Box>
              </Grid>
            </Grid>
            <Grid container direction="row" style={{ justifyContent: 'center' }}>
              <Grid item xs={10} direction="row">
                <Box sx={{ display: 'flex', justifyContent: 'space-between', p: '0px 32px' }}>
                  <FormControl sx={{ mt: 1, width: '45%' }} size="small">
                    <InputLabel id="enableExplainQuizOptions">Enable Explain Quiz Options</InputLabel>
                    <Select
                      label="Enable Explain Quiz Options"
                      name="enableExplainQuizOptions"
                      onChange={handleInputChange}
                      value={inputValue.enableExplainQuizOptions}
                    >
                      <MenuItem value={1}>1</MenuItem>
                      <MenuItem value={2}>2</MenuItem>
                      <MenuItem value={3}>3</MenuItem>
                    </Select>
                  </FormControl>
                  {inputValue.tenantName !== '' && inputValue.tenantName === constants.CHANNELS && (
                    <TextField
                      label="TOC ID"
                      style={{ minWidth: '45%' }}
                      margin="dense"
                      name="tocId"
                      onChange={handleInputChange}
                      value={inputValue.tocId}
                      variant="outlined"
                      required
                    />
                  )}
                </Box>
              </Grid>
            </Grid>
            <Grid container direction="row" style={{ justifyContent: 'center' }}>
              <Grid item xs={10} direction="row">
                <Box sx={{ display: 'flex', justifyContent: 'space-between', p: '0px 32px' }}>
                  <TextField
                    label="Book Title"
                    style={{ minWidth: '45%' }}
                    margin="dense"
                    name="bookTitle"
                    onChange={handleInputChange}
                    value={inputValue.bookTitle}
                    variant="outlined"
                    required
                  />
                </Box>
              </Grid>
            </Grid>
            <Grid container direction="row" style={{ justifyContent: 'center' }}>
              <Grid item xs={10} direction="row">
                <Box sx={{ display: 'flex', justifyContent: 'space-between', p: '0px 32px' }}>
                  <FormControl component="fieldset">
                    <FormGroup aria-label="position" row>
                      <FormControlLabel
                        className={classes.checkboxContainer}
                        control={
                          <Checkbox
                            onChange={handleInputChange}
                            checked={inputValue.enableProblemSolveFeature}
                            name="enableProblemSolveFeature"
                            color="primary"
                          />
                        }
                        label="Problem Solve Feature"
                        labelPlacement="start"
                      />
                      <FormControlLabel
                        className={classes.checkboxContainer}
                        control={
                          <Checkbox
                            name="showRecommendedPrompts"
                            onChange={handleInputChange}
                            checked={inputValue.showRecommendedPrompts}
                            color="primary"
                          />
                        }
                        label="Recommended Prompts"
                        labelPlacement="start"
                      />
                      <FormControlLabel
                        className={classes.checkboxContainer}
                        control={
                          <Checkbox
                            name="AIEnableHigherOrderSuggestion"
                            onChange={handleInputChange}
                            checked={inputValue.AIEnableHigherOrderSuggestion}
                            color="primary"
                          />
                        }
                        label="Higher Order Suggestion"
                        labelPlacement="start"
                      />
                      <FormControlLabel
                        className={classes.checkboxContainer}
                        control={
                          <Checkbox
                            name="AIEnableNewValidateAnswer"
                            onChange={handleInputChange}
                            checked={inputValue.AIEnableNewValidateAnswer}
                            color="primary"
                          />
                        }
                        label="New Validate Answer"
                        labelPlacement="start"
                      />
                      <FormControlLabel
                        className={classes.checkboxContainer}
                        control={
                          <Checkbox
                            name="AIEnableQuizRandomization"
                            onChange={handleInputChange}
                            checked={inputValue.AIEnableQuizRandomization}
                            color="primary"
                          />
                        }
                        label="Quiz Randomization"
                        labelPlacement="start"
                      />
                    </FormGroup>
                  </FormControl>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <Box>
          <Grid container direction="row" style={{ justifyContent: 'center' }}>
            <Grid item xs={12} direction="row">
              <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                <InputLabel className={classes.subLable}>Welcome Message</InputLabel>
                <TextareaAutosize
                  className={classes.textAreaSize}
                  name="message"
                  onChange={handleInputChange}
                  variant="outlined"
                  minRows={6}
                  maxRows={12}
                  value={inputValue.message}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
        <br />
        <div className={classes.flexContainerBottom}>
          <div className={classes.ButtonClass}>
            <Stack direction="row" spacing={2}>
              <Button
                variant="contained"
                size="small"
                onClick={() => handleSave()}
                sx={{ background: '#005d83' }}
                disabled={[
                  tenant,
                  inputValue.tenantId,
                  inputValue.tenantKey,
                  inputValue.courseId,
                  inputValue.productModel,
                  inputValue.bookTitle
                ].includes('')}
              >
                LAUNCH
              </Button>
            </Stack>
          </div>
          <div className={classes.ButtonClass}>
            {/* <div className={classes.versionText}>{`vega/aitutor-version - ${version}`}</div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default DynamicTestFields;
